import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import type { ExecutiveFilterState } from 'api/executive/executive.types'
import PerformanceApi from 'api/executive/performance.api'
import type {
  GetAppointmentDetailParams,
  GetAppointmentDetailResponse,
} from 'api/executive/executive.types'

export function useAppointmentDetail(scopedFilters?: Partial<ExecutiveFilterState>) {
  return useExecutiveQuery<GetAppointmentDetailParams, GetAppointmentDetailResponse>(
    'performance.appointment-detail',
    PerformanceApi.getAppointmentDetail,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
      }
    },
    { scopedFilters }
  )
}
